/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NDCByDrugName from '../../NDC/component/NDCByDrugName/NDCByDrugName';
import NDCByID from '../../NDC/component/NDCByID/NDCByID';
import NDCByLabeler from '../../NDC/component/NDCByLabeler/NDCByLabeler';
import {
  getAllNDCReferenceData,
  setNDCSelectedNDCTab,
} from '../../NDC/store/action';
import { NDC_TABS_DATA } from '../../../System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/utils/constant';

const CalculatedInterestNDCTabs = ({
  setErrorMessages,
  fullScreen,
  setFullScreen,
}) => {
  const dispatch = useDispatch();
  const selectedNDCTab = useSelector(
    (state) => state.sharedState.ndc.selectedNDCTab
  );
  const ndcSearchError = useSelector(
    (state) => state.sharedState.ndc.errorPopupMessage
  );

  useEffect(() => {
    dispatch(getAllNDCReferenceData());
  }, []);
  useEffect(() => {
    if (ndcSearchError && ndcSearchError != '')
      setErrorMessages((arr) => [...arr, ndcSearchError]);
  }, [ndcSearchError]);

  // can be used for default selections if needed
  // useEffect(() => {
  //   if (userDefaults && userDefaults.defNdcSelectModeCd) {
  //     dispatch(
  //       setNDCSelectedNDCTab(
  //         NDC_TABS_DATA[
  //           userDefaults.defNdcSelectModeCd === 'NDC'
  //             ? 0
  //             : userDefaults.defNdcSelectModeCd === 'LABELER'
  //             ? 2
  //             : 1
  //         ].value
  //       )
  //     );
  // } else {
  //   dispatch(setNDCSelectedNDCTab(NDC_TABS_DATA[0].value));
  //   }
  // }, [userDefaults]);

  return (
    <>
      <div className="tabs-container p-0">
        {selectedNDCTab === NDC_TABS_DATA[0].value ? (
          <div className="cal-interest-ndc-container">
            <NDCByID
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              isViewNDCHidden
            />
          </div>
        ) : selectedNDCTab === NDC_TABS_DATA[1].value ? (
          <NDCByDrugName
            isViewNDCHidden
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : (
          <div className="cal-interest-laberer-container">
            <NDCByLabeler
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              isViewNDCHidden
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CalculatedInterestNDCTabs;
